import { createVariantSelectorTree } from "../../../../utils/mappers/server-to-client/utils/create-variant-facet-tree.js";
import { getCommercialCategories } from "../../../../utils/mappers/server-to-client/utils/get-commercial-categories.js";
import { createFlatVariantList } from "../../../../utils/mappers/server-to-client/utils/create-flat-variant-list.js";
const mapServerToProductBase = (serverProduct, variants, facetConfigList, flatFacetConfigList) => {
  const variantFacetTree = facetConfigList?.length ? createVariantSelectorTree(variants, facetConfigList) : [];
  const commercialCategories = getCommercialCategories(serverProduct.commercialCategories);
  const flatFacetVariants = flatFacetConfigList?.length ? createFlatVariantList(variants, flatFacetConfigList) : [];
  return {
    id: serverProduct.id,
    name: serverProduct.name,
    brandName: serverProduct.brand,
    masterSku: serverProduct.variants[0].sku,
    variantFacetTree,
    commercialCategories,
    analyticsData: {
      category: serverProduct?.categories[0]?.name ?? void 0,
      ratingsSummary: serverProduct.ratingsSummary ?? void 0,
      vatRate: serverProduct.taxCategory?.rate?.amount ?? void 0
    },
    supplier: serverProduct.supplier ?? void 0,
    flatFacetVariants,
    //booleans
    isReviewEnabled: !!serverProduct.isReviewEnabled,
    isPublished: serverProduct.isPublished
  };
};
export {
  mapServerToProductBase
};
//# sourceMappingURL=map-server-to-product-base.js.map
